import luxonImpl, { LuxonImpl, TimeBoxFormats as LuxonTimeBoxFormats } from './timeboxLuxonImpl';
import localTimeHelper from './localTimeHelper';
export default function getLuxonImpl() {
    return {
        impl: luxonImpl,
        box: LuxonImpl,
        timebox: LuxonImpl,
        Formats: LuxonTimeBoxFormats,
        helper: (tz) => localTimeHelper(tz)(luxonImpl, LuxonImpl),
    };
}
